import React, { useState, useEffect } from "react";
import { useAuth } from "../../context/AuthContext";
import { FaCheckCircle, FaExclamationCircle } from "react-icons/fa";

const PhotoStorageSettings = () => {
  const { fetchWithRetry } = useAuth();
  const [config, setConfig] = useState({
    storageType: "local",
    cloudinary: {
      cloudName: "df1jy7bp4",
      apiKey: "421389118974837",
      apiSecret: "XkQuoH24hNBnPV5vXjHqz_B0RM0",
    },
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);

  useEffect(() => {
    const fetchConfig = async () => {
      try {
        const response = await fetchWithRetry({ method: "get", url: "/api/admin/photo-storage-config" });
        setConfig(response.data);
      } catch (err) {
        setError("Không thể tải cài đặt lưu trữ ảnh!");
      }
    };
    fetchConfig();
  }, [fetchWithRetry]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name.startsWith("cloudinary.")) {
      const field = name.split(".")[1];
      setConfig({
        ...config,
        cloudinary: { ...config.cloudinary, [field]: value },
      });
    } else {
      setConfig({ ...config, [name]: value });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    setSuccess(null);

    try {
      await fetchWithRetry({
        method: "put",
        url: "/api/admin/photo-storage-config",
        data: config,
      });
      setSuccess("Cập nhật cài đặt lưu trữ ảnh thành công!");
    } catch (err) {
      setError(err.response?.data?.message || "Lỗi khi cập nhật cài đặt lưu trữ ảnh!");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-white p-6 rounded-lg shadow-lg">
      <h2 className="text-2xl font-bold mb-4">Cài đặt lưu trữ ảnh</h2>

      {error && (
        <div className="bg-red-100 border-l-4 border-red-500 text-red-700 p-4 mb-4 rounded flex items-center">
          <FaExclamationCircle className="mr-2" /> {error}
        </div>
      )}
      {success && (
        <div className="bg-green-100 border-l-4 border-green-500 text-green-700 p-4 mb-4 rounded flex items-center">
          <FaCheckCircle className="mr-2" /> {success}
        </div>
      )}

      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label className="block text-sm font-medium text-gray-700">Loại lưu trữ</label>
          <select
            name="storageType"
            value={config.storageType}
            onChange={handleChange}
            className="mt-1 block w-full border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500"
          >
            <option value="local">Máy chủ cục bộ</option>
            <option value="cloudinary">Cloudinary</option>
          </select>
        </div>

        {config.storageType === "cloudinary" && (
          <div className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-gray-700">Cloud Name</label>
              <input
                type="text"
                name="cloudinary.cloudName"
                value={config.cloudinary.cloudName}
                onChange={handleChange}
                className="mt-1 block w-full border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500"
                placeholder="Tên cloud của bạn"
                required
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">API Key</label>
              <input
                type="text"
                name="cloudinary.apiKey"
                value={config.cloudinary.apiKey}
                onChange={handleChange}
                className="mt-1 block w-full border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500"
                placeholder="API Key của bạn"
                required
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">API Secret</label>
              <input
                type="password"
                name="cloudinary.apiSecret"
                value={config.cloudinary.apiSecret}
                onChange={handleChange}
                className="mt-1 block w-full border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500"
                placeholder="API Secret của bạn"
                required
              />
            </div>
          </div>
        )}

        <button
          type="submit"
          disabled={loading}
          className="bg-blue-500 text-white px-4 py-2 rounded-lg hover:bg-blue-600 transition duration-200 disabled:bg-gray-400"
        >
          {loading ? "Đang lưu..." : "Lưu cài đặt"}
        </button>
      </form>
    </div>
  );
};

export default PhotoStorageSettings;